export default {

	init() {
		console.log('init form...');
		document.addEventListener("DOMContentLoaded", this.bindEvents);
	},

	bindEvents() {
		$('.animated-labels input').on('focus', function(){
			$(this).closest('.oneField').addClass('focused');
		});

		$('.animated-labels input').on('blur', function(){
			if(!$(this).val()) $(this).closest('.oneField').removeClass('focused');
		});

		$('#advisors-zip-form .input-wrapper input').on('focus', function(){
			$(this).closest('.input-wrapper').addClass('focused');
		});

		setTimeout(function(){
			console.log('run');
			if($('#wFormThankYouPage').length) {
				document.getElementById('wFormThankYouPage').scrollIntoView({
					behavior: 'smooth',
				});
			}
		}, 1000);

		setTimeout(function(){
			$('.animated-labels input').each(function(){
				if($(this).val()) $(this).closest('.oneField').addClass('focused');
			});
		}, 500);


		setTimeout(function(){
			let url = new URL(window.location.href);
			let selectedOption = url.searchParams.get('fa_selected_option');
			if(selectedOption && $('#' + selectedOption + '[type="checkbox"]').length) {
				$('#' + selectedOption + '[type="checkbox"]').prop('checked', true);
			}
		}, 2500);

		setTimeout(function(){
			const newContactUrl = Form.getHomeTestContactUrl();
			console.log(newContactUrl);

			if(newContactUrl) {
				$('a:not(.no-url-change)').each(function(){
					let href = $(this).attr('href');
					if(href.includes('contact-us') && !href.includes('contact-us-')) {
						href = href.replace('contact-us', newContactUrl);
						$(this).attr('href', href);
					}
				});
			}
		}, 1000);

		if($('.fa-ajax-submit').length) {
			$('.fa-ajax-submit').on('submit', 'form', function(e){
				e.preventDefault();
				const form = $(this);

				let isValid = true;
				form.closest('.sh-block-wrapper').find('.section:not(.offstate) input.required').each(function(){
					if(!$(this).val()) isValid = false;
				});

				if(isValid) {
					const values = form.serialize();
					$.post(form.attr('action'), values, function(response){
						const responseHTML = $.parseHTML(response);
						let responseText = '';
						$('.wFormThankYou', responseHTML).each(function(){
							responseText = $(this).html();
						});
						form.after(responseText);
						form.hide();
					});
				}
			});
		}

		$('.wForm .inputWrapper input[title="Phone Number"]').keyup(function() {
			$(this).val($(this).val().replace(/^(\d{3})(\d{3})(\d+)$/, "$1-$2-$3"));
		});
		
		if($('.seven-step-form').length) {
			const parentFormClass = '.seven-step-form';

			if($('#cta-form-dropdown').length) {
				$('#cta-form-dropdown').on('change', function(){
					const val = $(this).val();
					const options = $(this).find('option');
					options.each(function(){
						const optionValue = $(this).attr('value');
						if(optionValue.length) {
							const isSelected =  optionValue == val;
							const checkedValue = isSelected ? 'checked' : '';
							// console.log(optionValue);
							// console.log($('#' + optionValue), checkedValue);
							$('#' + optionValue).prop('checked', checkedValue);
						}
					});

					if($('#scroll-to-cta-form').length) {
						let href = $('#scroll-to-cta-form').attr('href');
						const hrefPrefix = href.split('?');
						console.log(href);
						console.log(hrefPrefix);
						href = hrefPrefix[0] + '?fa_selected_option=' + val;
						console.log(href);
						$('#scroll-to-cta-form').attr('href', href);
					}
				});
	
			}

			$('.seven-step-form').on('keyup', '.wForm .wfCurrentPage input.required', function(){
				console.log('changed');
				disableNextButtonIfRequiredNotPassed($(this).closest('.wfCurrentPage').attr('id'));
			});

			setTimeout(function(){
				// console.log($('.seven-step-form').find('.wfCurrentPage, .wfPage').length, $('.seven-step-form').find('.wfCurrentPage, .wfPage'));
				$('.seven-step-form').find('.wfCurrentPage, .wfPage:not(#wfPgIndex-7)').each(function(){
					const pageId = $(this).attr('id');
					let pageButtonExists = setInterval(function(){
						if($('#' + pageId + '-buttons .wfPageNextButton').length) {
							clearInterval(pageButtonExists);
							if($(this).has('input.required')) disableNextButtonIfRequiredNotPassed(pageId);
						} else {
							console.log('not found')
						}
					}, 500);
				});
			}, 500);

			function disableNextButtonIfRequiredNotPassed(pageId) {
				const pageEl = $('#' + pageId);
				let requiredPass = true;
				$('#' + pageId + ' input.required').each(function(){
					if(!$(this).val()) requiredPass = false;
					if($(this).attr('title') && $(this).attr('title') == 'Phone Number') {
						if($(this).val().length !== 12) requiredPass = false;
						if($(this).val() != $(this).val().replace(/^(\d{3})(\d{3})(\d+)$/, "$1-$2-$3")) requiredPass = false;
					}
					
					if($(this).attr('title') && $(this).attr('title').toLowerCase().includes('email')) {
						if(!$(this).val().includes('@')) requiredPass = false;
						if($(this).val().includes(' ')) requiredPass = false;
					}

				});

				console.log('requiredPass', requiredPass);
				$('#' + pageId + '-buttons .wfPageNextButton').prop('disabled', !requiredPass);
			}

			$(parentFormClass).on('click', '.wfPageNextButton, .wfPagePreviousButton', function(e){
				const documentScroll = $(document).scrollTop();
				$(document).scrollTop(documentScroll);
			});

			if($('#scroll-to-cta-form').length) {
				setTimeout(function(){
					let newContactUrl = Form.getHomeTestContactUrl();
					if(!newContactUrl) newContactUrl = 'contact-us';

					console.log(newContactUrl);

					$('#scroll-to-cta-form').attr('href', '/' + newContactUrl + '/');				

					// let wrapperId;
					// $('.cta-form').each(function(){
					// 	console.log($(this));
					// 	wrapperId = $(this).closest('.sh-block-wrapper').attr('id');
					// });

					// console.log(wrapperId);

					// if(wrapperId) $('#scroll-to-cta-form').attr('href', '#' + wrapperId);				
				}, 50);
			}

			// if($('body.page-home-c .sh-block-wrapper.cta a[data-bs-toggle]').length) {
			// 	setTimeout(function(){
			// 		let newContactUrl = Form.getHomeTestContactUrl();
			// 		if(!newContactUrl) newContactUrl = 'contact-us';

			// 		console.log(newContactUrl);

			// 		const el = $('body.page-home-c .sh-block-wrapper.cta a[data-bs-toggle]');

			// 		el.removeAttr('data-bs-toggle').removeAttr('data-bs-target').attr('href', '/' + newContactUrl + '/');				
			// 	}, 50);
			// }

			// $(parentFormClass).on('change', 'form .current input', function(){
			// 	let validPage = true;
			// 	let parentDiv = $(this).closest('.current');
			// 	const pageId = parentDiv.attr('id');

			// 	parentDiv.find('input').each(function(){
			// 		if($(this).attr('aria-required')) {
			// 			if(!$(this).val()) validPage = false;
			// 		}
			// 	});

			// 	$('#' + pageId + ' input.next').prop('disabled', !validPage);
			// });

			// $(parentFormClass).on('click', '#submit_button:not(.verifiedClick)', function(e){
			// 	e.stopPropagation();

			// 	const button = $(this);
			// 	const captchaDiv = $(this).closest('form').find('.captcha').hide();

			// 	button.addClass('verifiedClick').val('Loading...').prop('disabled', true);
			// 	setTimeout(function(){
			// 		button.closest('form').submit();
			// 	}, 1000);
			// });


			let formLoaded = setInterval(function(){

				if($(parentFormClass + ' form .wfPage, ' + parentFormClass + ' form .wfCurrentPage').length) {
					clearInterval(formLoaded);

					let formJson;
					if($('#form-140-options').length) {
						formJson = $('#form-140-options').html();
						formJson = JSON.parse(formJson);
					} else if($('#form-96-options').length) {
						formJson = $('#form-96-options').html();
					console.log(formJson);
						formJson = JSON.parse(formJson);
					}

					// console.log(formJson);

					let buttonTextTimeout = setInterval(function(){
						if($(parentFormClass + ' form .wfPagePreviousButton').length && $(parentFormClass + ' form .wfPageNextButton').length) {
							clearInterval(buttonTextTimeout);

	    					//Update button text
							$(parentFormClass + ' form .wfPagePreviousButton').each(function(){
								$(this).val('Previous');
	    					});

							$(parentFormClass + ' form .wfPageNextButton').each(function(){
								$(this).val('Next');
	    					});
						} else {
							console.log('No buttons yet');
						}
					}, 500);

					//Drawer buttons same width
					setTimeout(function(){
						if($('.drawer-page-intro-bottom').length) {
							let buttonWidthTimeout = setInterval(function(){
								if($('.drawer-page-intro-bottom').find('a').length) {
									clearInterval(buttonWidthTimeout);
									let buttonWidth = 0;
									$('.drawer-page-intro-bottom').find('a').each(function(){
										console.log(this.offsetWidth);
										if(buttonWidth < this.offsetWidth) buttonWidth = this.offsetWidth;
										this.offsetWidth;
									});

									buttonWidth++; //ceil

									$('.drawer-page-intro-bottom').find('a, input').each(function(){
										$(this).css('width', buttonWidth + 'px');
									});
								}
							}, 500);

						}
					}, 1000);

					setTimeout(function(){
						$(parentFormClass + ' form .inputWrapper > select').each(function(){
							const select = $(this);
							const parentDiv = $(this).closest('.oneField');
							const label = parentDiv.find('> label');
							const labelContent = label.html();

							label.html('').hide();

							select.find('option').each(function(){
								if(!$(this).val().length) {
									$(this).html(labelContent);
								}
							});
    					});

						$(parentFormClass + ' form .wfPage, ' + parentFormClass + ' form .wfCurrentPage').each(function(){
	    					const page = $(this);

							const pageId = $(this).attr('id');

							const pageNumberDiv = $(this).find('h4');
							const pageNumber = pageNumberDiv.html();

	    					const bgColorWidth = pageNumber / 7;


						    const bgColorRule = 'background-image: '
							    + '-webkit-gradient(linear, left top, right top, '
							    + 'color-stop(' + bgColorWidth + ', var(--range-color)), '
							    + 'color-stop(' + bgColorWidth + ', var(--bg-color))'
							    + ')';

							pageNumberDiv.before('<div class="page-number-range-wrapper"><div class="progress-text">Step ' + pageNumber + ' of 7</div><input class="page-number-range" type="range" value="' + pageNumber + '" style="' + bgColorRule + '" min="0" max="7"></div>')
							// console.log(pageNumber);

							let validPage = true;
							$(this).find('input').each(function(){
								if($(this).attr('aria-required')) {
									if(!$(this).val()) validPage = false;
								}
							});

							if(!validPage) $('#' + pageId + ' input.next').prop('disabled', true);

							if(Object.keys(formJson).length) {
								const pageOptions = formJson[pageId];

								const hasCtaDropdown = $('#cta-form-dropdown').length;
								if(pageOptions !== undefined && Object.keys(pageOptions).length) {
									$(this).find('input').each(function(){
										const inputId = $(this).attr('id');
				
										if(pageOptions[inputId] !== undefined && Object.keys(pageOptions[inputId]).length) {
											if(pageOptions[inputId].hasOwnProperty('svg')) {
												let svg = pageOptions[inputId].svg.replace(/\\(.)/mg, "$1");
												$('label[for="' + inputId + '"]').append(svg);
											}
											if(pageOptions[inputId].hasOwnProperty('subtitle')) {
												let subtitle = pageOptions[inputId].subtitle.replace(/\\(.)/mg, "$1");
												$('label[for="' + inputId + '"]').append('<div class="subtitle">' + subtitle + '</div>');
											}
											if(hasCtaDropdown && pageOptions[inputId].hasOwnProperty('dropdown_text')) {
												const label = pageOptions[inputId].dropdown_text;
												const value = inputId;
												$('#cta-form-dropdown').append('<option value="' + value + '">' + label + '</option>');
												console.log(pageOptions, inputId);
											}
										}
									});
								}
							}
						});
					}, 50);
				}
			}, 1000);
		}

		if($('#contact-subjects-dropdown').length && $('#contact-subjects-cta').length) {
			const contactUrl = $('#contact-page-url').val();
			$('#contact-subjects-dropdown').on('change', function(){
				const select = $(this);
				const value = select.val();
				const options = select.find('option');
				let selectedOption;
				options.each(function(){
					if(value == $(this).attr('value')) selectedOption = $(this);
				});

				const button = $('#contact-subjects-cta');
				let buttonUrl;
				if(selectedOption.attr('special_url')) {
					buttonUrl = selectedOption.attr('special_url');
					$('#contact-subjects-cta').attr('target', '_blank');
				} else {
					buttonUrl = contactUrl + '?form_comments_text=' + value;
					$('#contact-subjects-cta').attr('target', '_self');
				}

				$('#contact-subjects-cta').attr('href', buttonUrl);
			});		

			$('#contact-subjects-cta').attr('href', contactUrl);
		}

		if($('.seven-step-form').length) {
			const urlParams = new URLSearchParams(document.location.search);

			if(urlParams.get('form_comments_text')) {
				const commentsText = urlParams.get('form_comments_text');
				$('#wfPgIndex-7').find('textarea').each(function(){
					$(this).val(commentsText);
				});
			}
		}
	},

	getHomeTestContactUrl() {
		if($('body').hasClass('page-home-a')) {
			return 'contact-us';
		}
		if($('body').hasClass('page-home-b')) {
			return 'contact-us';
		}
		if($('body').hasClass('page-home-c')) {
			return 'contact-us';
		}

		return false;
	}

};
